import { render } from "./CarouselProduct.vue?vue&type=template&id=6f4b61b9&scoped=true"
import script from "./CarouselProduct.vue?vue&type=script&lang=js"
export * from "./CarouselProduct.vue?vue&type=script&lang=js"

import "./CarouselProduct.vue?vue&type=style&index=0&id=6f4b61b9&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4b61b9"]])

export default __exports__